/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlbumResponse } from '../../models/album-response';

export interface AlbumsControllerDeletePhoto$Params {
  id: string;
  photoId: string;
}

export function albumsControllerDeletePhoto(http: HttpClient, rootUrl: string, params: AlbumsControllerDeletePhoto$Params, context?: HttpContext): Observable<StrictHttpResponse<AlbumResponse>> {
  const rb = new RequestBuilder(rootUrl, albumsControllerDeletePhoto.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('photoId', params.photoId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AlbumResponse>;
    })
  );
}

albumsControllerDeletePhoto.PATH = '/albums/admin/{id}/photos/{photoId}';
